import { _ as _asyncToGenerator, r as regenerator } from '../index-33ee6c9f.js';
import { _ as _defineProperty } from '../defineProperty-377d5a7f.js';
import { _ as _slicedToArray } from '../slicedToArray-b4278ecd.js';
import fetch from 'isomorphic-fetch';
import LRU from '../LRUCache/index.js';
import { CURRENT_LANGUAGE_COOKIE_NAME, LANGUAGE_HEADER_KEY } from '../configs/constants/index.js';
import IS_BROWSER from '../isBrowser/index.js';
import { authorizationHeader } from '../services/auth/index.js';
import getDeviceId from '../getDeviceId/index.js';
import RequestStore from '../RequestStore/index.js';
import { getCookie } from '../cookie/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var lruCache = new LRU(50);
var makeUnique = function makeUnique(url, method, data) {
  return "".concat(url, "-").concat(method, "-").concat(data);
};
var getRequestOptions = function getRequestOptions(options) {
  var myHeaders = new Headers();
  options.headers && Object.entries(options.headers).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return myHeaders.append(key, value);
  });
  return _objectSpread(_objectSpread({}, options), {}, {
    headers: myHeaders
  });
};
var getDeviceIdAndLanguage = function getDeviceIdAndLanguage(device, language) {
  return _objectSpread(_objectSpread({}, device && getDeviceId() && {
    deviceId: getDeviceId()
  }), language && _defineProperty({}, LANGUAGE_HEADER_KEY, getCookie(CURRENT_LANGUAGE_COOKIE_NAME)));
};
var getHeaders = function getHeaders(initialHeaders, options) {
  return {
    headers: _objectSpread(_objectSpread({}, initialHeaders), options === null || options === void 0 ? void 0 : options.headers)
  };
};
var getOptions = function getOptions(initialHeaders, options, withDeviceId, withLanguageHeader) {
  return _objectSpread(_objectSpread(_objectSpread({}, options), getHeaders(initialHeaders || {}, options)), getDeviceIdAndLanguage(withDeviceId, withLanguageHeader));
};
var getFromCache = function getFromCache(hash) {
  return lruCache.read(hash);
};
var cacheResults = function cacheResults(res, useCache, hash) {
  if (res.status === 200 && useCache) {
    lruCache.set(hash, res);
  }
};
var handleRequest = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(url, options) {
    var useCache,
      hash,
      result,
      request,
      _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          useCache = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;
          hash = makeUnique(url, options.method || 'GET', options);
          if (!(useCache && lruCache.has(hash))) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", getFromCache(hash));
        case 4:
          _context.prev = 4;
          if (!IS_BROWSER) {
            _context.next = 14;
            break;
          }
          request = fetch(url, getRequestOptions(options));
          RequestStore.set(hash, request);
          _context.next = 10;
          return request;
        case 10:
          result = _context.sent;
          RequestStore.drop(hash);
          _context.next = 17;
          break;
        case 14:
          _context.next = 16;
          return fetch(url, getRequestOptions(options));
        case 16:
          result = _context.sent;
        case 17:
          cacheResults(result, useCache, hash);
          return _context.abrupt("return", result);
        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](4);
          console.error('Error handling your request:', _context.t0);
          throw _context.t0;
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 21]]);
  }));
  return function handleRequest(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();
function fetchFactory(configs) {
  var baseUrl = configs.baseUrl,
    cacheEnabled = configs.withCache,
    headers = configs.headers,
    withDeviceId = configs.withDeviceId,
    withLanguageHeader = configs.withLanguageHeader,
    accessToken = configs.accessToken;
  var headersWithAuth = _objectSpread(_objectSpread({}, authorizationHeader(accessToken)), headers);
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(url, options, withCache) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return handleRequest("".concat(baseUrl).concat(url), getOptions(headersWithAuth, options, withDeviceId, withLanguageHeader), withCache !== null && withCache !== void 0 ? withCache : cacheEnabled);
          case 3:
            return _context2.abrupt("return", _context2.sent);
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            console.error('Error handling your request:', _context2.t0);
            throw _context2.t0;
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 6]]);
    }));
    return function (_x3, _x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
}

export { fetchFactory as default };
//# sourceMappingURL=index.js.map
